"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MhInfinityTable = void 0;

var _babelHelperVueJsxMergeProps = _interopRequireDefault(require("@vue/babel-helper-vue-jsx-merge-props"));

var _vuePropertyDecorator = require("vue-property-decorator");

var _lodash = require("lodash");

var _dec, _dec2, _dec3, _dec4, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _temp;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

var computeState = function computeState(_ref, _ref2) {
  var pageSize = _ref.pageSize;
  var direction = _ref2.direction,
      scrollTop = _ref2.scrollTop,
      scrollHeight = _ref2.scrollHeight,
      tableHeight = _ref2.tableHeight,
      visibleHeight = _ref2.visibleHeight,
      size = _ref2.size;

  if (scrollHeight === 0) {
    return {
      startIndex: 0,
      underHeight: 0,
      upperHeight: 0,
      visibleRowCount: 0
    };
  }

  var rowHeight = tableHeight / pageSize;
  var visibleRowCount = Math.ceil(visibleHeight / rowHeight);
  var startIndex = Math.floor(scrollTop / scrollHeight * size);

  if (direction === 'up') {
    startIndex -= pageSize - visibleRowCount;
    startIndex = startIndex < 0 ? 0 : startIndex;
  } else {
    startIndex = startIndex + pageSize > size ? size - pageSize : startIndex;
  }

  var underHeight = Math.round((size - (startIndex + pageSize)) * rowHeight);
  startIndex = startIndex > 0 ? startIndex : 0;
  var upperHeight = Math.round(startIndex * rowHeight);
  return {
    visibleRowCount: visibleRowCount,
    startIndex: startIndex,
    underHeight: underHeight,
    upperHeight: upperHeight
  };
};

var MhInfinityTable = (_dec = (0, _vuePropertyDecorator.Prop)({
  default: 30
}), _dec2 = (0, _vuePropertyDecorator.Prop)(), _dec3 = (0, _vuePropertyDecorator.Prop)(), _dec4 = (0, _vuePropertyDecorator.Prop)({
  default: function _default() {
    return [];
  }
}), (0, _vuePropertyDecorator.Component)(_class = (_class2 = (_temp = /*#__PURE__*/function (_VueComponent) {
  _inherits(MhInfinityTable, _VueComponent);

  var _super = _createSuper(MhInfinityTable);

  function MhInfinityTable() {
    var _this;

    _classCallCheck(this, MhInfinityTable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _initializerDefineProperty(_this, "renderSize", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_this, "loading", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_this, "dataSource", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_this, "columns", _descriptor4, _assertThisInitialized(_this));

    _this.size = 0;
    _this.scrollTop = 0;
    _this.scrollHeight = 0;
    _this.tableHeight = 0;
    _this.visibleRowCount = 0;
    _this.startIndex = 0;
    _this.refUpperPlaceholder = null;
    _this.refUnderPlaceholder = null;
    _this.refScroll = null;
    _this.refTable = null;
    _this.setStateWithThrottle = (0, _lodash.throttle)(_this.updateTable, 200);
    _this.io = null;
    _this.ioTargetState = {
      refUnderPlaceholder: null,
      refUpperPlaceholder: null,
      refTable: null
    };
    return _this;
  }

  _createClass(MhInfinityTable, [{
    key: "mounted",
    value: function mounted() {
      this.refScroll = this.$refs.root.getElementsByClassName('ant-table-body')[0];
      this.refTable = this.refScroll && this.refScroll.getElementsByTagName('tbody')[0];
      this.createUpperPlaceholder();
      this.createUnderPlaceholder();

      if (!this.refScroll) {
        return;
      }

      this.io = new IntersectionObserver(this.observerScrollCallBack, {
        root: this.refScroll
      });
      this.toggleObserver();
    }
  }, {
    key: "beforeUpdate",
    value: function beforeUpdate() {// this.beforeRender();
    }
  }, {
    key: "destroyed",
    value: function destroyed() {
      if (this.refScroll) {
        this.refScroll.removeEventListener('scroll', this.setStateWithThrottle);
      }

      if (this.io) {
        this.io.disconnect();
      }
    }
  }, {
    key: "createUpperPlaceholder",
    value: function createUpperPlaceholder() {
      var refUpperPlaceholder = document.createElement('div');
      refUpperPlaceholder.setAttribute('class', 'ref-upper-placeholder');
      this.refScroll && this.refScroll.insertBefore(refUpperPlaceholder, this.refScroll.firstChild);
      this.refUpperPlaceholder = refUpperPlaceholder;
    }
  }, {
    key: "createUnderPlaceholder",
    value: function createUnderPlaceholder() {
      var refUnderPlaceholder = document.createElement('div');
      refUnderPlaceholder.setAttribute('class', 'ref-under-placeholder');
      this.refScroll && this.refScroll.appendChild(refUnderPlaceholder);
      this.refUnderPlaceholder = refUnderPlaceholder;
    }
  }, {
    key: "updateTable",
    value: function updateTable() {
      if (!this.refScroll || !this.refTable || !this.refUpperPlaceholder || !this.refUnderPlaceholder) {
        return;
      }

      var tableHeight = this.refTable.clientHeight;
      var _this$refScroll = this.refScroll,
          scrollHeight = _this$refScroll.scrollHeight,
          visibleHeight = _this$refScroll.clientHeight,
          scrollTop = _this$refScroll.scrollTop;
      var size = this.dataSource.length;
      var obj = computeState({
        pageSize: this.renderSize
      }, {
        direction: scrollTop - this.scrollTop < 0 ? 'up' : 'down',
        scrollTop: scrollTop,
        visibleHeight: visibleHeight,
        scrollHeight: scrollHeight,
        tableHeight: tableHeight,
        size: size
      });
      this.startIndex = obj.startIndex;
      this.visibleRowCount = obj.visibleRowCount;
      this.tableHeight = tableHeight;
      this.size = size;
      this.scrollTop = scrollTop;
      this.refUnderPlaceholder.style.height = obj.underHeight + 'px';
      this.refUpperPlaceholder.style.height = obj.upperHeight + 'px';
      this.refScroll.scrollTo(0, scrollTop);
    }
  }, {
    key: "observerScrollCallBack",
    value: function observerScrollCallBack(changes) {
      var _this2 = this;

      if (!this.refScroll || !this.refTable) {
        return;
      }

      this.refScroll.removeEventListener('scroll', this.setStateWithThrottle); // if (this.scrollTop && Math.abs(this.refScroll.scrollTop - this.scrollTop) < 20) {
      //   return;
      // }

      this.ioTargetState = changes.reduce(function (result, change) {
        var ret = _objectSpread({}, result);

        switch (change.target) {
          case _this2.refUnderPlaceholder:
            ret.refUnderPlaceholder = change;
            break;

          case _this2.refUpperPlaceholder:
            ret.refUpperPlaceholder = change;
            break;

          case _this2.refTable:
            ret.refTable = change;
            break;

          default:
            console.warn('Miss match dom', change);
        }

        return ret;
      }, this.ioTargetState);
      var mutation = 'cache scrolling';
      var _this$ioTargetState = this.ioTargetState,
          refUnderPlaceholder = _this$ioTargetState.refUnderPlaceholder,
          refUpperPlaceholder = _this$ioTargetState.refUpperPlaceholder,
          refTable = _this$ioTargetState.refTable;
      var startIndex = this.startIndex,
          visibleRowCount = this.visibleRowCount,
          size = this.size,
          loading = this.loading;
      var pageSize = this.renderSize;

      if (refUnderPlaceholder.intersectionRatio > 0) {
        if (refTable.intersectionRatio > 0 && startIndex + pageSize + visibleRowCount >= size && !loading) {
          // 已滚动到最后，加载数据
          mutation = 'end';
          this.scrollTop = this.refScroll.scrollTop;
          this.scrollHeight = this.refScroll.scrollHeight;
          this.tableHeight = this.refTable.clientHeight;
          return null; // mutation = 'fastEnd'; // 滚动到最后，但数据已经加载完
        } else if (refTable.intersectionRatio > 0) {
          mutation = 'down'; // 滚动到显示的数据未尾
        } else if (refTable.intersectionRatio === 0) {
          mutation = 'fastDown'; // 滚动到没有任何数据显示的区域
        }
      } else if (refUpperPlaceholder.intersectionRatio > 0) {
        if (refUpperPlaceholder.intersectionRatio === 1) {
          mutation = 'top'; // 滚动到顶了
        } else if (refTable.intersectionRatio > 0) {
          mutation = 'up'; // 滚动到显示的数据头部
        } else if (refTable.intersectionRatio === 0) {
          mutation = 'fastUp'; // 滚动到没有任何数据显示的区域
        }
      } else if (refTable.intersectionRatio === 0) {
        // fix bug: 重新触发，获取正确值
        this.toggleObserver(false);
        this.toggleObserver();
        return;
      }

      if (mutation.includes('fast')) {
        this.refScroll.addEventListener('scroll', this.setStateWithThrottle);
      }

      this.setStateWithThrottle();
    }
  }, {
    key: "toggleObserver",
    value: function toggleObserver() {
      var condition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!this.io || !this.refTable || !this.refUnderPlaceholder || !this.refUpperPlaceholder) {
        return;
      }

      if (condition) {
        this.io.observe(this.refUpperPlaceholder);
        this.io.observe(this.refUnderPlaceholder);
        this.io.observe(this.refTable);
      } else {
        this.io.unobserve(this.refUpperPlaceholder);
        this.io.unobserve(this.refUnderPlaceholder);
        this.io.unobserve(this.refTable);
      }
    } // public beforeRender() {
    //   const {
    //     tableHeight,
    //     scrollHeight: prevStateScrollHeight,
    //     visibleRowCount,
    //     size,
    //     renderSize: pageSize,
    //     loading,
    //   } = this;
    //
    //   const length = this.dataSource.length;
    //
    //   if (pageSize < visibleRowCount) {
    //     console.warn(
    //       `pagesize(${pageSize}) less than visible row count(${visibleRowCount}), maybe you set error!`,
    //     );
    //   }
    //
    //   const rowHeight = tableHeight / pageSize;
    //
    //   const increase = length - size;
    //
    //   let scrollHeight = Math.round(prevStateScrollHeight + increase * rowHeight);
    //   if (!loading) {
    //     scrollHeight = length * rowHeight;
    //   }
    //
    //   if (pageSize < increase) {
    //     console.warn(
    //       `increase(${increase}) greater than pageSize(${pageSize}) that will cause the scroll bar shake, maybe you set error! `,
    //     );
    //   }
    //   const obj = computeState(
    //     { pageSize },
    //     Object.assign({}, this, {
    //       direction:
    //         this.refScroll && this.refScroll.scrollTop - this.scrollTop < 0
    //           ? 'up'
    //           : 'down',
    //       size: length,
    //       scrollHeight,
    //     }),
    //   );
    //   this.isPropsChange = true;
    //   this.upperHeight = obj.upperHeight;
    //   this.underHeight = obj.underHeight;
    //   this.startIndex = obj.startIndex;
    //   this.size = length;
    //   this.visibleRowCount = obj.visibleRowCount;
    //   if (this.refUpperPlaceholder && this.refUnderPlaceholder) {
    //     (this.refUnderPlaceholder as any).style.height = this.underHeight + 'px';
    //     (this.refUpperPlaceholder as any).style.height = this.upperHeight + 'px';
    //     this.refScroll && this.refScroll.scrollTo(0, this.scrollTop);
    //   }
    // }

  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var h = arguments[0];
      var startIndex = this.startIndex,
          dataSource = this.dataSource,
          renderSize = this.renderSize,
          columns = this.columns;
      var list = dataSource.slice(startIndex, startIndex + renderSize);
      return h("div", {
        "class": "mh-table mh-infinity-table",
        "ref": "root"
      }, [h("a-table", (0, _babelHelperVueJsxMergeProps.default)([{}, {
        props: _objectSpread(_objectSpread({}, this.$attrs), {}, {
          pagination: false,
          dataSource: list,
          columns: columns.map(function (col) {
            return col.customRender ? _objectSpread(_objectSpread({}, col), {}, {
              customRender: function customRender(text, record, index) {
                return col.customRender(text, record, index, list);
              }
            }) : col;
          })
        }),
        on: {
          change: function change(e) {
            return _this3.$emit('change', e);
          }
        },
        ref: 'table'
      }]))]);
    }
  }], [{
    key: "install",
    value: function install(vue) {
      vue.component('mh-infinity-table', this);
    }
  }]);

  return MhInfinityTable;
}(_vuePropertyDecorator.Vue), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "renderSize", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "loading", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "dataSource", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "columns", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
exports.MhInfinityTable = MhInfinityTable;